/**
 * Chemins de la feature `purchases` — centralisés ici pour éviter les paths
 * hardcodés dans les vues, les routes et la navigation (cf. front/CLAUDE.md §3).
 */
export const PURCHASES_PATHS = {
  /** Catalogue des offres. */
  root: '/purchases',
  /** Achat du test complet (toutes les évaluations). */
  complete: '/purchases/complete',
  /** Sélection d'un pack d'évaluations. */
  packEval: '/purchases/pack-eval',
  /** Historique des achats de l'utilisateur. */
  history: '/my-purchases',
  /**
   * Retour Stripe après paiement réussi. Doit correspondre à `SUCCESS_URL`
   * configuré côté ms-payment (`http://localhost:5173/payment/success` en local).
   */
  paymentSuccess: '/payment/success',
  /** Retour Stripe après annulation. Doit correspondre à `CANCEL_URL` ms-payment. */
  paymentCancel: '/payment/cancel',
  /**
   * L'abonnement Skill-Up (SAAS-1311) : les formules sans abonnement,
   * « Mon abonnement » sinon. Une seule entrée de menu pour les deux.
   */
  subscription: '/subscription',
  /**
   * Retour Stripe après une souscription. Doit correspondre à
   * `SUBSCRIPTION_SUCCESS_URL` côté ms-payment (SAAS-1308).
   */
  subscriptionSuccess: '/subscription/success',
  /** Retour Stripe après abandon. Doit correspondre à `SUBSCRIPTION_CANCEL_URL`. */
  subscriptionCancel: '/subscription/cancel',
} as const;

/** Conditions générales de vente, citées avant tout paiement. */
// TODO: remplacer par l'URL réelle des Conditions Générales de Vente.
export const CGV_URL = 'https://alt.bzh/cgv';

/** La gamme d'abonnement vendue par SAAS-1311 (contrat SAAS-A-214). */
export const SKILL_UP_PRODUCT_LINE = 'skill-up';

/**
 * Drapeau de l'abonnement : coupé en prod jusqu'au lancement, ouvert en
 * staging via la variable CI `VITE_FEATURE_FLAGS_STAGING`.
 */
export const SUBSCRIPTIONS_FLAG = 'subscriptions';
